import { render, staticRenderFns } from "./sectionFiles.vue?vue&type=template&id=5a005c69&scoped=true"
import script from "./sectionFiles.vue?vue&type=script&lang=js"
export * from "./sectionFiles.vue?vue&type=script&lang=js"
import style0 from "./sectionFiles.vue?vue&type=style&index=0&id=5a005c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a005c69",
  null
  
)

export default component.exports